import { Component } from "react";

import List from "@material-ui/core/List";
import ListingItem from "../LisingItem";

import { moneyFormater } from "../../../../utilities/formaters";

export default class ApplicationOffer extends Component {
  boolRenderer = (value) => {
    if (value === true) {
      return "Yes";
    }

    if (value === false) {
      return "No";
    }

    return "not set";
  };

  render() {
    let listStyle = {
      border: "1px solid rgb(217, 217, 217)",
      width: "200px",
      float: "left",
      padding: "4px",
    };
    let acceptedStyle = Object.assign({}, listStyle, {
      border: "1px solid #144914",
    });

    return (
      <div>
        {this.props.LoanOffers && this.props.LoanOffers.length
          ? this.props.LoanOffers.map((offer, index) => {
              return (
                <List
                  key={"offermaping" + index}
                  style={offer.Accepted ? acceptedStyle : listStyle}
                >
                  <ListingItem
                    primaryText={offer.OfferType}
                    secondaryText="Offer type"
                  />
                  <ListingItem
                    primaryText={this.boolRenderer(offer.Accepted)}
                    secondaryText="Accepted"
                  />
                  <ListingItem
                    primaryText={this.boolRenderer(offer.LastAccepted)}
                    secondaryText="Last accepted"
                  />
                  <ListingItem
                    primaryText={
                      offer.LoanAmount
                        ? moneyFormater(offer.LoanAmount.Amount) + "kr"
                        : "not set"
                    }
                    secondaryText="Loan amount"
                  />
                  <ListingItem
                    primaryText={offer.LoanTerm ? offer.LoanTerm : "not set"}
                    secondaryText="Loan term"
                  />
                  <ListingItem
                    primaryText={
                      offer.NominalInterest
                        ? Math.round(offer.NominalInterest.Value * 100 * 100) /
                            100 +
                          "%"
                        : "not set"
                    }
                    secondaryText="Nominal interest"
                  />
                  <ListingItem
                    primaryText={
                      offer.EffectiveInterest
                        ? Math.round(
                            offer.EffectiveInterest.Value * 100 * 100,
                          ) /
                            100 +
                          "%"
                        : "not set"
                    }
                    secondaryText="Effective interest"
                  />
                  <ListingItem
                    primaryText={
                      offer.IntermediationFeeRate
                        ? Math.round(
                            offer.IntermediationFeeRate.Value * 100 * 100,
                          ) /
                            100 +
                          "%"
                        : "not set"
                    }
                    secondaryText="Origination fee rate"
                  />
                  <ListingItem
                    primaryText={
                      offer.Annuity
                        ? moneyFormater(offer.Annuity.Amount) + "kr"
                        : "not set"
                    }
                    secondaryText="Annuity"
                  />
                  <ListingItem
                    primaryText={
                      offer.InvoiceFee
                        ? moneyFormater(offer.InvoiceFee.Amount) + "kr"
                        : "not set"
                    }
                    secondaryText="Admin fee"
                  />
                </List>
              );
            })
          : "no loan offers"}
      </div>
    );
  }
}
